export const loginCallback = async (navigate) => {
  const addCarInProgress = localStorage.getItem("addCarInProgress");
  if (addCarInProgress === "true") {
    navigate("/cars/add");
    return true;
  }
  return false;
};
